// @ts-check
/**
 * Mirrors ASSISTANT_ACTION_STATUS in /shared/api-constants.js. The admin build cannot import that file
 * (CRA refuses imports outside src); utils/assistantStatus.test.js keeps this copy honest.
 */
export const ASSISTANT_ACTION_STATUS = Object.freeze({
  PENDING: 'pending',
  EXECUTING: 'executing',
  COMPLETED: 'completed',
  SHIPMENT_FAILED: 'shipment_failed',
  FAILED: 'failed',
  EXPIRED: 'expired',
  SUPERSEDED: 'superseded',
});
